import { storage, type StorageKey } from 'app/lib/storage';

export function getAlertHideKey(hideKey: string) {
  return `alert-${hideKey}`;
}

export async function isAlertHidden(hideKey: string) {
  const storedPreference = await storage.readString(getAlertHideKey(hideKey) as StorageKey);
  return storedPreference ? (JSON.parse(storedPreference) as boolean) : false;
}
